import { Component } from '@angular/core';
import { InboxService } from '../../../../services/inbox/inbox.service';

@Component({
  selector: 'app-inbox',
  templateUrl: './inbox.component.html',
  styleUrls: ['./inbox.component.css']
})
export class InboxComponent {

  constructor(
    public inboxService: InboxService
  ) {}

  public getCustomersInboxCount() {
    const inboxCounts = this.inboxService.getInboxCounts();

    return (
      inboxCounts.documents_pending_staff_approval +
      inboxCounts.linked_account_requests +
      inboxCounts.invalid_documents +
      inboxCounts.potential_duplicate_customers
    );
  }

  public getMembershipsAndPassesInboxCount() {
    const inboxCounts = this.inboxService.getInboxCounts();

    return (
      inboxCounts.memberships_pending_staff_approval +
      inboxCounts.unlinked_membership_customers +
      inboxCounts.unlinked_entry_pass_customers
    );
  }

  public getEventsInboxCount() {
    const inboxCounts = this.inboxService.getInboxCounts();

    return (
      inboxCounts.unlinked_reservations +
      inboxCounts.unlinked_voucher_pack_customers
    );
  }

  public getAssociationsInboxCount() {
    const inboxCounts = this.inboxService.getInboxCounts();

    return (
      inboxCounts.association_join_requests
    );
  }

}
